import { copyPaymentPlanApi, createPaymentPlanApi, createPaymentPlanItemApi, deletePaymentPlanApi, deletePaymentPlanItemApi, editPaymentPlanApi, editPaymentPlanItemApi, syncProjectPaymentPlansApi, } from '../api';
const paymentPlansActions = {
    createPaymentPlan: async (paymentPlan) => {
        try {
            const { data: res } = await createPaymentPlanApi(paymentPlan);
            return res;
        }
        catch (error) {
            // @ts-ignore
            throw error?.response?.data;
        }
    },
    editPaymentPlan: async (paymentPlan, { setState }) => {
        try {
            const { data: res } = await editPaymentPlanApi(paymentPlan);
            setState((state) => {
                if (state.project.data) {
                    const index = state.project.data.paymentPlans.findIndex(({ id }) => id === res.id);
                    state.project.data.paymentPlans[index] = res;
                }
            });
            return res;
        }
        catch (error) {
            // @ts-ignore
            throw error?.response?.data;
        }
    },
    copyPaymentPlan: async ({ paymentPlan, projectIds }) => {
        try {
            const { data: res } = await copyPaymentPlanApi(paymentPlan, projectIds);
            return res;
        }
        catch (error) {
            // @ts-ignore
            throw error?.response?.data;
        }
    },
    deletePaymentPlan: async (paymentPlan, { setState }) => {
        try {
            await deletePaymentPlanApi(paymentPlan);
            setState((state) => {
                if (state.project.data) {
                    state.project.data.paymentPlans = state.project.data.paymentPlans.filter(({ id }) => id !== paymentPlan.id);
                }
            });
        }
        catch (error) {
            // @ts-ignore
            throw error?.response?.data;
        }
    },
    createPaymentPlanItem: async (payload) => {
        try {
            const { data: res } = await createPaymentPlanItemApi(payload);
            return res;
        }
        catch (error) {
            // @ts-ignore
            throw error?.response?.data;
        }
    },
    editPaymentPlanItem: async (payload, { setState }) => {
        try {
            const { data: res } = await editPaymentPlanItemApi(payload);
            setState((state) => {
                const paymentPlan = state.project?.data?.paymentPlans?.find(({ id }) => id === res.paymentPlanId);
                const index = paymentPlan?.items?.findIndex(({ id }) => id === res.id);
                if (paymentPlan && index && index >= 0) {
                    paymentPlan.items[index] = res;
                }
            });
            return res;
        }
        catch (error) {
            // @ts-ignore
            throw error?.response?.data;
        }
    },
    deletePaymentPlanItem: async (payload, { setState }) => {
        try {
            await deletePaymentPlanItemApi(payload);
            setState((state) => {
                if (state.project.data) {
                    const paymentPlan = state.project.data.paymentPlans.find(({ id }) => id === payload.paymentPlanId);
                    if (paymentPlan) {
                        paymentPlan.items = paymentPlan.items.filter(({ id }) => id !== payload.id);
                    }
                }
            });
        }
        catch (error) {
            // @ts-ignore
            throw error?.response?.data;
        }
    },
    syncProjectPaymentPlans: async ({ id, payload }, { setState }) => {
        try {
            const { data: res } = await syncProjectPaymentPlansApi(id, { ids: payload });
            setState((state) => {
                if (state.project.data) {
                    state.project.data.paymentPlans = res;
                }
            });
            return res;
        }
        catch (error) {
            // @ts-ignore
            throw error?.response?.data;
        }
    },
};
export default paymentPlansActions;
